import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=d4954a96&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=ts&"
export * from "./privacy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=d4954a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4954a96",
  null
  
)

export default component.exports